import { render } from "./gameListItem.vue?vue&type=template&id=2508ee3a&scoped=true"
import script from "./gameListItem.vue?vue&type=script&lang=js"
export * from "./gameListItem.vue?vue&type=script&lang=js"

import "./gameListItem.vue?vue&type=style&index=0&id=2508ee3a&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2508ee3a"]])

export default __exports__